<tec-tile
	[title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.TYPE_PICKER_TITLE' | translate"
	[scrollable]="true"
>
	<div class="grid grid-e2-sm">
		@for (preset of fieldPresets; track preset.id) {
			<tec-item
				[title]="preset.labelKey | translate"
				[tagImage]="{ icon: preset.icon, status: preset.iconStatus }"
				[selected]="selectedPresetId === preset.id"
				(click)="selectPreset(preset)"
			/>
		}
	</div>
</tec-tile>
